import React from "react";
import moment from "moment";

// Components
import VideoLikeDislike from "./VideoLikeDislike";
import ShareButtons from "../../../../Menus/ShareButtons";
import VideoRedirects from "./VideoRedirects";
import HorizontalSubscribeCTA from "../../../Conversion/HorizontalSusbcribeCTA";
import Donate from "../../../Conversion/Donate";
import ExpandableContentBox from "../../../StaticInfo/ExpandableContentBox";

// Models
import VideoDTO from "../../../../../Models/DTOs/VideoDTO";
import {ContentType} from "../../../../../Models/Enums/ContentType";
import useFetchSubscriptionPlans from "../../../../../Hooks/Plans/useFetchSubscriptionPlans";

interface VideoInfoProps {
    video: VideoDTO;
    isVideoLoading: boolean;
    disableRating?: boolean;
    disableDescription?: boolean;
    disableDateAndEpisodeInfo?: boolean;
    isTrailer?: boolean;
    doesAuthTokenExist: boolean;
}

const VideoPrimaryInformation: React.FC<VideoInfoProps> = (
    {
        video,
        isVideoLoading,
        disableRating,
        disableDescription,
        disableDateAndEpisodeInfo,
        isTrailer,
        doesAuthTokenExist,
    }
) => {
    const {plans} = useFetchSubscriptionPlans();
    return (
        <div className="watch-video__primary-info">
            {video.IsFreeView && !doesAuthTokenExist && (
                <div className="primary-info__freeview-cta">
                    <HorizontalSubscribeCTA plans={plans ? plans : []}/>
                </div>
            )}

            <div className="primary-info__top-row">
                {/** Title and Date **/}
                <div className="primary-info__title-and-date">
                    <p
                        className={`primary-info__date-and-series ${
                            isVideoLoading ? "loader--side-to-side" : "is-loaded"
                        }`}
                    >
                        {!isVideoLoading && disableDateAndEpisodeInfo !== true && (
                            <>
                                {moment(video.Datetime).format("Do MMMM YYYY").toString()}{" "}
                                {video.SeriesId && video.SeriesId > 0
                                    ? `• Series ${video.Season} - Episode ${video.Episode}`
                                    : null}
                            </>
                        )}
                    </p>

                    <h1 className={isVideoLoading ? "loader--side-to-side" : "is-loaded"}>
                        {!isVideoLoading && video.Title} {isTrailer === true ? "Trailer" : ""}
                    </h1>
                </div>

                {/** Socials and Likes **/}
                <div className="primary-info__auxillary-info">
                    <div className="primary-info__rating-and-share">
                        <div>
                            {disableRating !== true && (
                                <VideoLikeDislike video={video} isVideoLoading={isVideoLoading}/>
                            )}

                            <ShareButtons
                                displayText={true}
                                title={video.Title}
                                contentType={
                                    video.SeriesId === null || video.SeriesId === undefined
                                        ? ContentType.Film
                                        : ContentType.Episode
                                }
                            />
                        </div>
                    </div>

                    <VideoRedirects video={video} />
                </div>
            </div>

            {/** Description **/}
            <div className="primary-info__description-and-extra-cta">
                {!disableDescription && (
                    <ExpandableContentBox
                        collapsedHeight={50}
                        className="primary-info__description-container"
                        moreLabel="…More"
                        lessLabel="Show Less"
                    >
                        <p>{video.Description}</p>
                    </ExpandableContentBox>
                )}

                <Donate/>
            </div>
        </div>
    );
};

export default VideoPrimaryInformation;
